import { palette } from '@livable/saas-react-components';
const MuiLinearProgress = {
  styleOverrides: {
    root: {
      backgroundColor: palette.shades[300],
      width: '100%',
      display: 'inline-block'
    },
    determinate: {
      borderRadius: '4px'
    },
    bar: {
      backgroundColor: 'transparent',
      background: palette.brandGradients.main
    }
  }
};
export default MuiLinearProgress;